import { fetchJson } from '@atlassian/help-center-common-util/fetch/fetch';
import { getThirdPartyConnectionStatusEndpoint } from '../../common/constants';
import type { IntegrationDetails } from '../../common/types';

interface fetchConnectionStatusArgs {
    cloudId: string;
}
export const fetchConnectionStatus = ({ cloudId }: fetchConnectionStatusArgs): Promise<IntegrationDetails[]> =>
    fetchJson(`${getThirdPartyConnectionStatusEndpoint()}/${cloudId}`, {
        method: 'GET',
    });
